export default "__VITE_ASSET__4V5fJY6d__"